import { createContext } from 'react';

import { TourContextType } from './Tour.types';

export const TourContext = createContext<TourContextType>({ hasTour: false });
